{
  "srTitle": "مشروع مكافحة سفاري البشر — حماية المدنيين من الطائرات المسيّرة في خيرسون، أوكرانيا",
  "logoAlt": "شعار مشروع مكافحة سفاري البشر",
  "intro": "نوفّر معدات الحماية ضد هجمات الطائرات المسيّرة الصغيرة للمتطوعين وخدمات الطوارئ والعاملين في البنية التحتية الحيوية في خيرسون، أوكرانيا.",
  "safari": "منذ صيف 2024، يُطارَد المدنيون في خيرسون بشكل ممنهج من قِبل الجيش الروسي باستخدام طائرات مسيّرة مزوّدة بكاميرات، في حملة إرهاب تُعرف باسم «سفاري البشر» (Human Safari).",
  "unLink": "لجنة الأمم المتحدة تعترف بـ«سفاري البشر» كجريمة حرب",
  "donateNow": "تبرّع الآن",
  "donateMonthly": "تبرّع شهريًا",
  "otherWays": "طرق أخرى للتبرّع",
  "instagram": "Instagram",
  "pastFundraisers": "حملات التبرّع السابقة:",
  "fundraiser2025": "حملة تبرّع 2025",
  "donateVia": "تبرّع عبر:",
  "charityRef": "عبر جمعية خيرية بريطانية، مع الإشارة:",
  "germanCharityRef": "عبر جمعية خيرية ألمانية، مع الإشارة:",
  "copy": "نسخ",
  "copied": "تم النسخ!",
  "close": "إغلاق",
  "viewMedia": "عرض الوسائط",
  "andrushenkoCredit": "أولكسندر أندريوشينكو، مصوّر صحفي في وسيلة الإعلام «Vgoru»",
  "fruitSellerDescription": "بائع فاكهة تطارده طائرة مسيّرة موجّهة بالألياف البصرية",
  "khersonPoliceCredit": "من @khersonpolice",
  "firefighterDescription": "رجل إطفاء يُخمد حريق سيارة بعد ضربة في «سفاري البشر»، وخلفه يرقد أحد الضحايا",
  "previousMedia": "السابق",
  "nextMedia": "التالي",
  "fpvDroneDescription": "طائرة مسيّرة من نوع FPV في مهمة ضمن «سفاري البشر»",
  "busAttackDescription": "واحد من هجمات كثيرة بطائرات FPV المسيّرة على وسائل النقل العام",
  "notFoundTitle": "الصفحة غير موجودة",
  "notFoundMessage": "هذه الصفحة غير موجودة. ربما تم نقلها أو أن الرابط غير صحيح.",
  "backHome": "العودة إلى الصفحة الرئيسية",
  "droneDetectorDescription": "أجهزة كشف الطائرات المسيّرة هي أجهزة محمولة صغيرة تنبّه عند اقتراب طائرة مسيّرة",
  "vestDescription": "يمكن للسترات الواقية الخفيفة أن تخفف من شدة الإصابات الناجمة عن هجوم بطائرة مسيّرة"
}
